<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "Medicine"
}
</script>

<style>

</style>